import React from 'react';
import PrimeFactorization from './components/PrimeFactorization';

function App() {
  return (
    <div>
      <PrimeFactorization />
    </div>
  );
}

export default App;
